import { date } from "colbi_web_ui/lib/utils";
import I18n from "../../I18n";

export const severityRender = (type) => {
    switch (parseInt(type, 10)) {
        case 0:
            return "Low";
        case 1:
            return "Medium";
        case 2:
            return "High";
        case 3:
            return "Critical";
        default:
            return;
    }
};

const header = [
    { label: ["Line Number"], align: "left", basis: "10%" },
    { label: ["Column Number"], align: "left", basis: "10%" },
    { label: ["Message"], align: "left", basis: "60%" },
    { label: ["Reference"], align: "left", basis: "10%" },
    { label: ["Created At"], align: "center" },
];

export const translateFindingMessage = (message) => (message ? I18n.translate(message) : "");

export const buildDetailPanelAuditResults = (json) => ({
    F3: translateFindingMessage(json?.message),
    F4: json?.type || "",
    F1: json?.lineNumber || "",
    F2: json?.columnNumber || "",
    F6: json?.xmlBlock || "",
});

const mapCard = (json) => {
    const { message, referenceType, createdAt, referenceId, lineNumber, columnNumber, type } = json;

    const referenceTypeFormatted = referenceType ? referenceType.split("::").pop() : "";

    return [
        [{ labels: ["lineNumber"], value: lineNumber || "N/A", type: "string", basis: "10%" }],
        [{ labels: ["columnNumber"], value: columnNumber || "N/A", type: "string", basis: "10%" }],
        [
            {
                labels: ["message"],
                value: translateFindingMessage(message) || "N/A",
                type: "string",
                basis: "60%",
            },
        ],
        [
            referenceId
                ? {
                      label: "Refers to",
                      value: {
                          id: referenceId,
                          name: referenceTypeFormatted,
                          __typename: referenceTypeFormatted,
                      },
                      type: "object",
                  }
                : {
                      labels: ["message"],
                      value: type ? type.toLowerCase() : "N/A",
                      type: "string",
                      basis: "10%",
                  },
        ],
        [{ labels: ["createdAt"], value: date(createdAt), type: "date" }],
    ];
};

export const mapDetails = (json) => {
    const {
        line,
        column,
        xmlBlock,
        originalMessage,
        type,
        referenceType,
        createdAt,
        severity,
        referenceId,
    } = json;

    let others = [];

    const referenceTypeFormatted = referenceType ? referenceType.split("::").pop() : "";

    if (type !== "RulesFinding") {
        others = [
            [
                { label: "Line", value: line || "N/A", type: "string" },
                { label: "Column", value: column || "N/A", type: "string" },
            ],
            [
                { label: "XML Block", value: xmlBlock || "N/A", type: "string" },
                {
                    label: "Original Message",
                    value: originalMessage || "N/A",
                    type: "string",
                },
            ],
        ];
    }

    return [
        [
            {
                label: "Type",
                value: type,
                type: "string",
            },
            {
                label: "Severity",
                value: severityRender(severity),
                type: "string",
            },
            {
                label: "Refers to",
                value: {
                    id: referenceId,
                    name: referenceTypeFormatted,
                    __typename: referenceTypeFormatted,
                },
                type: "object",
            },

            {
                label: "Creation Date",
                value: date(createdAt),
                type: "date",
            },
        ],
        [],
        ...others,
    ];
};

const mapper = (json, card) => {
    const name = translateFindingMessage(json.message);
    return {
        ...json,
        __typename: json.__typename,
        id: json.id,
        name,
        shortName: name,
        card: card ? mapCard(json) : [],
        details: mapDetails(json),
        link: json.id
            ? {
                  to: `/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/:modulePrefix/audit_findings/${json.id}`,
              }
            : null,
        detailPanel: {
            data: json ? buildDetailPanelAuditResults(json) : undefined,
            detailPanelComponent: "AuditSchemaDetails",
        },
    };
};

const findinglinesMapper = {
    map: mapper,
    header,
    showDetailPanel: true,
};

export default findinglinesMapper;
